import { useEffect, useState } from "react"
import ReservationPrice from "./ReservationPrice/ReservationPrice"
import useHttp from "../../../../hooks/use-http"
import KeyValueTable from "../../../../UI/KeyValueTable/KeyValueTable"
import { datetimeFormatter, euroFormatter } from "../../../../functions/Formatters/formatters"
import i18n from "../../../../i18n"
import FormBlock from "../../../../components/Form/FormBlock"
import Icon from "../../../../icons/Icon"


const ReservationOverview = (props) => {

    const [reservationData, setReservationData] = useState(null)
    const [reload, setReload] = useState(true)
    const [addDiscountCoupon, setAddDiscountCoupon] = useState(false)
    const [disabled, setDisabled] = useState(true)
    const {isLoading : getFormLoading, error : getFormError, sendRequest : getData} = useHttp((data) => {setReservationData(data)})

    useEffect(() => {  
        if(reload){
            getData({url:'/rest/reservation/current/retrieve_store/', json:true})
            setReload(false)
        }
    }, [reload])  

    if(!reservationData){
        return <div></div>
    }

    const table_fields = {
        'full_name': i18n.t('Name'),
        'company': i18n.t('Company'),
        'quantity': i18n.t('Quantity'), 
        'people': i18n.t('People'),
        'email': i18n.t('Email'),
        'phone': i18n.t('Phone'), 
    }
    const addition_fields = <>
        {reservationData.payment_method_object &&
        <tr>
            <td>{i18n.t('Payment method')}</td>
            <td>{reservationData.payment_method_object.name}</td>
        </tr>
        }
        <tr>
            <td>{i18n.t('Start time')}</td>
            <td>{datetimeFormatter(reservationData.from_time)}</td>
        </tr>   
        <tr>
            <td>{i18n.t('End time')}</td>
            <td>{datetimeFormatter(reservationData.to_time)}</td>
        </tr>
        <tr>
            <td>{i18n.t('Total time')}</td>
            <td>{reservationData.duration_rounded}</td>
        </tr>
    </> 
    const saveHook = (forms, index)=> {
        if(forms[index].success){
            setDisabled(false)
        }else{
            setDisabled(true)
        }
        setReload(true)
    }
    const processCalback = (data) => {
        const fields = data.forms[0].fields
        if(Object.keys(fields).filter(field => !fields[field].value).length === 0){
            setDisabled(false)
        }
    }
    return <div className="container">
        <div className="w-100 row my-4">
            <div className="col-12 col-md-4">
                <KeyValueTable original={reservationData} allowed={table_fields} >
                    {addition_fields}
                </KeyValueTable>
            </div>
            <div className="col-12 col-md-8">
                <ReservationPrice data={reservationData}/>
                <div className="d-flex justify-content-end align-items-center mt-2">
                    <a className="text-dark p-1" type="button" onClick={()=>setAddDiscountCoupon(true)}><Icon name="ICON_PLUS" /> {i18n.t('Add discount coupon')}</a>
                </div>
                {addDiscountCoupon &&
                <div className="col-12 col-md-8 ms-auto d-flex justify-content-end">
                    <FormBlock url={`/rest/reservation/current/add_discount_coupon/`} saveHook={()=>setReload(true)} inline={true} processCalback={processCalback} />
                </div>
                }
            </div>
            <div className="col-12 col-md-8">
            </div>
            <div className="justify-content-center align-items-end mt-3 ms-auto col-12 col-md-8" >
                <FormBlock url={`/rest/reservation/current/add_options/`} saveHook={saveHook} processCalback={processCalback} autoSave={true} />
                {disabled ? <div className="alert alert-danger">{i18n.t('Please fill in the form')}</div> : null}
            </div>
            {  reservationData.deposit_amount && (reservationData.deposit_amount !=  reservationData.total_amount_in_vat)?
                <div className="justify-content-center mt-3 ms-auto col-12 col-md-8 alert alert-warning" >
                    <i className="bi bi-info-circle me-2"/>
                    {i18n.t('You only need to pay a deposit to confirm the booking:')} {euroFormatter(reservationData.deposit_amount)}
                </div>
            :null
            }
            {reservationData.reservation_errors?.length > 0 &&
                <div className="justify-content-center mt-3 ms-auto col-12 col-md-8 alert alert-danger" >
                    <i className="bi bi-info-circle me-2"/>
                    {reservationData.reservation_errors.map(error => <div key={error}>{error}</div>)}
                </div>
            }
            <div className="col-12 d-flex justify-content-end align-items-center mt-5">
                <a href="/rest/reservation/current/cancel_reservation/" className="border-2 smr-btn px-2 py-1 me-5" style={{color: 'var(--umr-danger)'}}>{i18n.t('Cancel')}</a>

                {disabled ? 
                <>
                    <a disabled={disabled} title={i18n.t('Please fill in the form')} style={{pointer: 'not-allowed'}} className="smr-btn smr-btn-outline-primary px-5 py-3">{i18n.t('Pay')}</a>
                </>
                :
                    <a href="/rest/reservation/current/pay_reservation/" className="border-2 smr-btn smr-btn-outline-primary px-5 py-3">{i18n.t('Pay')}</a>
                }
            </div>
        </div>
    </div>
}

export default ReservationOverview